// eslint-disable-next-line no-unused-vars
import { MenuItem, SystemFeatures } from "isuppli-react-components";

const menuItems: Array<MenuItem> = [
  {
    title: "General Audits",
    to: "/audit",
    feature: SystemFeatures.AuditTrails,
  }, {
    title: "Detailed Audits",
    to: "/auditdetail",
    feature: SystemFeatures.DetailedAuditTrails,
  }];

export default menuItems;
